import React from "react"
import { useTranslation } from "react-i18next"

const Pagination = ({ meta, onPageChange }) => {
  const { t } = useTranslation()
  const { page, total_pages } = meta

  return (
    <div className="flex items-center justify-between px-1 py-2">
      <span className="text-xs text-[#9AA5B4]">
        {t("admin_extension_tokens.pagination.page_of", { page, total: total_pages })}
      </span>
      <div className="flex gap-1.5">
        <button
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="px-3 py-1.5 rounded-lg border border-[#E7EAEF] bg-white text-sm text-[#1F2937]
                     hover:bg-[#F4F6F9] disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {t("admin_extension_tokens.pagination.prev")}
        </button>
        <button
          disabled={page >= total_pages}
          onClick={() => onPageChange(page + 1)}
          className="px-3 py-1.5 rounded-lg border border-[#E7EAEF] bg-white text-sm text-[#1F2937]
                     hover:bg-[#F4F6F9] disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {t("admin_extension_tokens.pagination.next")}
        </button>
      </div>
    </div>
  )
}

export default Pagination
